import { createSelector } from 'reselect';

const selectContactMessageState = state => state.ContactMessage;

export const selectIsFetching = createSelector(
  selectContactMessageState,
  (state, props) => state.fetching
);

export const selectIsUpdating = createSelector(
  selectContactMessageState,
  (state, props) => state.updating
);

export const selectError = createSelector(selectContactMessageState, (state, props) => state.error);



// WEBPACK FOOTER //
// ./src/store/graphql/ContactMessage/selectors.js